import React, { useState, useEffect } from "react";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Paper from '@mui/material/Paper'
import Button from "@mui/material/Button";
import darkTheme from '../../src/theme';
import TicketsModal from "../../components/modals/DealsTicketsModal";
import Skeleton from "@mui/material/Skeleton";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const ticketsCard = {    
    backgroundColor: darkTheme.palette.background.alternate,
    padding: darkTheme.spacing(3),
    marginTop: darkTheme.spacing(4),
    marginBottom: darkTheme.spacing(2),
    border:`1px solid`,
    borderColor: darkTheme.palette.background.ticket,
    borderRadius: 2,
    '& h4': {
        fontSize: 30,
        color: darkTheme.palette.primary.title, 
        textTransform:'unset !important',
        // marginBottom: darkTheme.spacing(1),    
        [darkTheme.breakpoints.down("sm")]: {
            fontSize: 18,      
        },
    },
    '& h5': {
        fontSize: 14,
        fontWeight: 400,    
        color: darkTheme.palette.primary.dates,           
    },
    '& h6': {
        fontSize: 16,
        color: darkTheme.palette.primary.location,
        fontWeight: 400,
        marginTop: darkTheme.spacing(0.75),
        marginBottom: darkTheme.spacing(0.75),
    },
    [darkTheme.breakpoints.down("sm")]: {
        marginTop: 0,
        marginBottom: 0,
        position: 'fixed',
        left: darkTheme.spacing(3),
        right: darkTheme.spacing(3),
        bottom: darkTheme.spacing(2),
        zIndex: 3,
        borderRadius: `15px`,  
        boxShadow: darkTheme.shadows[6],
        padding: darkTheme.spacing(2),
    }
};

function Tickets({ data }) {  
    const [isLoading, setIsLoading] = useState(true);
    const [open, setOpen] = useState(false);
    const [open1, setOpen1] = useState(false);
    const [loading, setLoading] = useState(false);
        
    const ticketsModalHandler = () => {
        setOpen(true);
        setLoading(true);
    };

    const onCloseTicketsModalHandler = () => {
        setOpen(false);
        setLoading(false);
    };

    const onCloseTicketsModalHandlerAlert = () => {
        setOpen(false);
        setLoading(false);
    };

    const onCloseTicketsModalHandlerAlert1 = () => {
        setOpen1(false);
        setLoading(false);
    };

    useEffect(() => {
    //   setUniqueId(props.uniqueId)
      setIsLoading(false)
    }, [])

  return (
      <>   
          {isLoading ? (
              <Skeleton
                  variant="rectangular"
                  height={100}
                  sx={{ borderRadius: "20px" }}
              />
          ) : (
              <Typography component="div" sx={ticketsCard}>
                  <Paper elevation={0}>
                      {data.status ? (
                          <Stack
                              direction="row"
                              justifyContent="space-between"
                              alignItems="center"
                              spacing={0}
                          >
                              <Typography variant="h4" sx={{mb:0}}>
                                {data.actual_price > 0 ? (
                                  <><Typography variant="span" sx={{fontSize:15}}>Starts at ₹ </Typography> <b>{data.actual_price}</b>
                                  <Typography variant="small"
                                      sx={{
                                          display: {
                                              xl: 'inline',
                                              lg: 'inline',
                                              md: 'inline',
                                              sm: 'none',
                                              xs: 'none'
                                          }, fontSize:14
                                      }}
                                  >&nbsp;
                                      for{" "}
                                              {data.entry_free_upto}&nbsp;person<small>(s).</small></Typography>                                  
                                      </>
                                ):(<Typography variant="p" sx={{fontSize:20, textTransform:'capitalize'}}>{('Reserve for Free').toLowerCase()}</Typography>)}
                              </Typography>                              
                                <Typography component="div" sx={{display:'flex', alignItems:'center', cursor:'pointer'}} onClick={ticketsModalHandler}>
                                    {/* <Typography component="h5" sx={{mb:0}}>Get Deal</Typography>  */}
                                        <span className="rippleBtn">
                                        <span><ArrowForwardIcon sx={{ fontSize: '14px', color: darkTheme.palette.primary.arrowColor, zIndex:3}} /></span>
                                    </span>
                                </Typography>
                          </Stack>
                      ) : (
                          <Stack
                              direction="row"
                              justifyContent="space-between"
                              alignItems="center"
                              spacing={0}
                          >
                              <Typography variant="h4">Sorry, you&apos;ve missed this deal.</Typography>
                              <Button
                                  sx={{
                                      py: 1,
                                      px: 2,
                                      alignSelf: "center",
                                      minWidth: '100px'
                                  }}
                                  variant="outlined"
                                  className="themeBtnAlt"
                                  disabled={true}
                              >
                                  Sold Out
                              </Button>
                          </Stack>
                      )}
                  </Paper>
              </Typography>
          )}
            <TicketsModal
                open={open}
                onClose={onCloseTicketsModalHandler}
                onCloseAlert={onCloseTicketsModalHandlerAlert}
                onCloseAlert1={onCloseTicketsModalHandlerAlert1}
                data={data}
            />          
    </>
  );
}

export default Tickets;
